import AchievementIcon from "../assets/achievement_icon.png";
import "../styles/achievement.css"

const AchievementComponent = ({ achivement }) => {
    return (
        <div className="achievement-component-container">
            <div className="achievement-card">
                <div className="column achievement-container">
                    <img className="icon" alt="Achievement" src={ AchievementIcon } />
                    <div className="badges">{`${achivement.display_name}`}</div>
                </div>
            </div>
        </div>
    )
}

export default AchievementComponent;